import { render, staticRenderFns } from "./AbsentLetterPage.vue?vue&type=template&id=ae09ccf8&scoped=true"
import script from "./AbsentLetterPage.vue?vue&type=script&lang=js"
export * from "./AbsentLetterPage.vue?vue&type=script&lang=js"
import style0 from "./AbsentLetterPage.vue?vue&type=style&index=0&id=ae09ccf8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae09ccf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae09ccf8')) {
      api.createRecord('ae09ccf8', component.options)
    } else {
      api.reload('ae09ccf8', component.options)
    }
    module.hot.accept("./AbsentLetterPage.vue?vue&type=template&id=ae09ccf8&scoped=true", function () {
      api.rerender('ae09ccf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/absent_letter_v3/AbsentLetterPage.vue"
export default component.exports